import { Switch } from "../../UI/Switch.tsx";

export function Article7TerSwitch({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <Switch label="Articolo 7 ter" checked={checked} onChange={onChange} />
  );
}
